import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import './Header.css';

const TRAITS = ['Developer', 'SQL Guru', 'AI Enthusiast', 'Data Engineer', 'Problem Solver'];
const TRAIT_ITEMS = [...TRAITS, ...TRAITS];

const SunIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="5"/>
    <line x1="12" y1="1" x2="12" y2="3"/>
    <line x1="12" y1="21" x2="12" y2="23"/>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
    <line x1="1" y1="12" x2="3" y2="12"/>
    <line x1="21" y1="12" x2="23" y2="12"/>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
);

const MoonIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);

function Header({ isLanding = false }) {
  const { isDark, toggleTheme } = useTheme();
  const [displayedName, setDisplayedName] = useState('');
  const fullName = 'ジョセフ　（ＪＭＨＪ)';

  useEffect(() => {
    if (isLanding) {
      let i = 0;
      const timer = setInterval(() => {
        if (i < fullName.length) {
          setDisplayedName(fullName.slice(0, i + 1));
          i++;
        } else {
          clearInterval(timer);
        }
      }, 100);
      return () => clearInterval(timer);
    } else {
      setDisplayedName(fullName);
    }
  }, [isLanding]);

  const navClass = ({ isActive }) => `nav-link${isActive ? ' active' : ''}`;

  return (
    <>
      <button onClick={toggleTheme} className="theme-toggle-fixed" aria-label="Toggle theme">
        {isDark ? <SunIcon /> : <MoonIcon />}
      </button>
      <header className={`header ${isLanding ? 'landing-header' : ''}`}>
      <div className="header-content">
        <div className="profile-image-ring">
          <picture>
            <source srcSet="/profile.webp" type="image/webp" />
            <img src="/White Background.png" alt="Profile" className="profile-image" loading="lazy" />
          </picture>
        </div>
        <div>
          <h1>{displayedName}<span className="cursor">|</span></h1>
          <div className={`trait-marquee${isLanding ? ' fade-in-delay' : ''}`}>
            <div className="trait-track">
              {TRAIT_ITEMS.map((t, i) => (
                <span key={i} className="trait-item">{t}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <nav>
        <NavLink to="/" className={navClass} end>Home</NavLink>
        <NavLink to="/projects" className={navClass}>Projects</NavLink>
        <NavLink to="/contact" className={navClass}>Contact</NavLink>
        <a href="https://jmhj.info" target="_blank" rel="noopener noreferrer" className="nav-link">Stats Dashboard</a>
      </nav>
      <div className="social-links">
        <a href="https://x.com/_jmhj" target="_blank" rel="noopener noreferrer">
          <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons@v9/icons/x.svg" alt="X/Twitter" />
        </a>
        <a href="https://discordapp.com/users/365859129165742091" target="_blank" rel="noopener noreferrer">
          <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons@v9/icons/discord.svg" alt="Discord" />
        </a>
        <a href="https://www.goodreads.com/user/show/145364540-jmhj" target="_blank" rel="noopener noreferrer">
          <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons@v9/icons/goodreads.svg" alt="Goodreads" />
        </a>
        <a href="https://open.spotify.com/user/jensenj.mh" target="_blank" rel="noopener noreferrer">
          <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons@v9/icons/spotify.svg" alt="Spotify" />
        </a>
        <a href="https://myanimelist.net/profile/jmhj" target="_blank" rel="noopener noreferrer">
          <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons@v9/icons/myanimelist.svg" alt="MyAnimeList" />
        </a>
        <a href="https://steamcommunity.com/id/jmhj" target="_blank" rel="noopener noreferrer">
          <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons@v9/icons/steam.svg" alt="Steam" />
        </a>
        <a href="https://jmhj.dev" target="_blank" rel="noopener noreferrer">
          <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons@v9/icons/github.svg" alt="GitHub" />
        </a>
      </div>

      {isLanding && (
        <div className="motto">
          <blockquote>
            "Science is what we understand well enough to explain to a computer; art is everything else."
            <cite>— Donald E. Knuth</cite>
          </blockquote>
        </div>
      )}
    </header>
    </>
  );
}

export default Header;